module.exports = __webpack_public_path__ + "img/profile.7cc9a685.svg";